import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared';
import { CpCommerceWebsiteFormFieldSetLinkContainerModel } from '../../../../../models/aggregates/website-form/cpcommerce-form-field-set-link-container.model';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';

@Injectable({
  providedIn: 'root'
})
export class CpCommerceFormFieldSetLinkService extends BaseApiPublicLoginTemplateService<CpCommerceWebsiteFormFieldSetLinkContainerModel,CpCommerceWebsiteFormFieldSetLinkContainerModel,CpCommerceWebsiteFormFieldSetLinkContainerModel> {

  static readonly CP_COMMERCE_FORM_FIELD_SET_LINK_PATH = 'website-form-field-set-links/';
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormFieldSetLinkService.CP_COMMERCE_FORM_FIELD_SET_LINK_PATH  + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormFieldSetLinkService.CP_COMMERCE_FORM_FIELD_SET_LINK_PATH  + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormFieldSetLinkService.CP_COMMERCE_FORM_FIELD_SET_LINK_PATH  + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.CPCOMMERCE_PREFIX + CpCommerceFormFieldSetLinkService.CP_COMMERCE_FORM_FIELD_SET_LINK_PATH  + BaseApiTemplateService.PUBLIC_EP;
  }
}

